import { render, staticRenderFns } from "./VehicleFiles.vue?vue&type=template&id=16f64180&scoped=true&"
import script from "./VehicleFiles.vue?vue&type=script&lang=js&"
export * from "./VehicleFiles.vue?vue&type=script&lang=js&"
import style0 from "./VehicleFiles.vue?vue&type=style&index=0&id=16f64180&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f64180",
  null
  
)

export default component.exports